import { render, staticRenderFns } from "./UserJobs.vue?vue&type=template&id=7971ddd4&scoped=true&"
import script from "./UserJobs.vue?vue&type=script&lang=js&"
export * from "./UserJobs.vue?vue&type=script&lang=js&"
import style0 from "./UserJobs.vue?vue&type=style&index=0&id=7971ddd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971ddd4",
  null
  
)

export default component.exports